import { EdgeSendContactClaimOtpRepository } from '@/modules/auth/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { SendContactClaimOtp } from '@/modules/auth/use-cases'

export function makeSendContactClaimOtp(): SendContactClaimOtp {
  return new EdgeSendContactClaimOtpRepository(makeSupabaseEdgeHttpClient()).execute
}
